<template>
  <div class="animated fadeIn arpaymfrm">
    <b-card>
      <div slot="header">
        {{this.$route.meta.title}}
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="8">
          <b-input-group>
              <b-input-group-prepend><span class="label-md">Payment Date</span></b-input-group-prepend>
              <b-form-input v-model="model.tglpaym" type="date" :state="!$v.model.tglpaym.$error"></b-form-input>
          </b-input-group>
          <b-input-group>
              <b-input-group-prepend><label class="label-md">Trx Bank No.</label></b-input-group-prepend>
              <b-form-input v-model="model.nomor" readonly></b-form-input>
              <b-input-group-prepend><span class="p-2">Collection No.</span></b-input-group-prepend>
              <b-form-input v-model="model.paymno" v-b-tooltip.hover title="Jika dikosongkan akan dibuatkan otomatis"></b-form-input>
          </b-input-group>
           <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><label class="label-md">No Agreement</label></b-input-group-prepend
                >
                <b-form-input
                  readonly
                  v-model="model.pinjamaninfo"
                ></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuPinjamanShow = true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><span class="p-2">No Kontrak</span></b-input-group-prepend
                >
                 <b-form-input
                  readonly
                  v-model="model.no_kontrak"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="8">
              <b-input-group>
                <b-input-group-prepend
                  ><label class="label-md">Terima Dari <br>(CIF|Nm. Debitur)</label></b-input-group-prepend
                >
                <b-form-input
                  readonly
                  v-model="model.custinfo"
                  :state="!$v.model.customer_id.$error"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="4">
              <b-input-group>
                <b-input-group-prepend
                  ><span class="p-2">Kolektor</span></b-input-group-prepend
                >
                <b-form-select
                  v-model="model.collector_id"
                  :plain="true"
                  :options="collectors"
                  disabled="disabled"
                ></b-form-select>
              </b-input-group>
            </b-col>
          </b-row>
         
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col lg="6">  
          <b-input-group>
            <b-input-group-prepend
              ><label style="min-width: 180px !important"
                >Jumlah Terima Kas/bank
              </label></b-input-group-prepend
            >
            <b-input-group-prepend
              ><span class="input-group-text" style="width: 70px">{{
                model.matauang
              }}</span></b-input-group-prepend
            >
            <div style="width:250px">
              <my-number
                class="form-control text-right my-number"
                separator=","
                v-model="model.totalbank"
                :state="!$v.model.totalbank.$error"
                :precision="2"
                :minus="true"
              ></my-number>
            </div>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend
              ><label style="min-width: 180px !important">Bank Charges</label></b-input-group-prepend
            >
            <b-input-group-prepend
              ><span class="input-group-text" style="width: 70px">{{
                model.matauang
              }}</span></b-input-group-prepend
            >
            <div style="width:250px">
              <my-number
              class="form-control text-right my-number"
              separator=","
              v-model="model.bcharges"
              :precision="2"
              
            ></my-number>
            </div>
            
          </b-input-group>
          <b-input-group v-if="model.matauang != uanguser">
            <b-input-group-prepend
              ><label style="width: 180px !important"
                >Nilai Kurs {{ model.matauang || "" }} ke {{ uanguser }}
              </label></b-input-group-prepend
            >
            <b-input-group-prepend
              ><span class="input-group-text" style="width: 70px">{{
                uanguser
              }}</span></b-input-group-prepend
            >
            <my-number
              class="form-control text-right my-number"
              separator=","
              v-model="model.kurstrx"
              :precision="6"
            ></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label style="min-width: 180px !important">Keterangan / <br />Catatan</label>
            </b-input-group-prepend>
            <b-form-textarea
              :rows="2"
              :max-rows="5"
              v-model="model.uraian"
              :state="!$v.model.uraian.$error"
            ></b-form-textarea>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row align-h="between">
        <b-col lg="6">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><label style="min-width: 180px !important">Payment Method</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="model.jenis"
                  :plain="true"
                  :options="jenisPaym"
                  :state="!$v.model.jenis.$error"
                ></b-form-select>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Due/Efective Date</label></b-input-group-prepend
                >
                <b-form-input
                  v-model="model.tgl_terima"
                  type="date"
                  :state="!$v.model.tgl_terima.$error"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              lg="6"
              v-if="model.jenis === 'Cheque' || model.jenis === 'Giro'"
            >
              <b-input-group>
                <b-input-group-prepend
                  ><label style="min-width: 180px !important">Cheque/Giro No.</label></b-input-group-prepend
                >
                <b-form-input v-model="model.nomorcek"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col
              lg="6"
              v-if="model.jenis === 'Cheque' || model.jenis === 'Giro'"
            >
              <b-input-group>
                <b-input-group-prepend
                  ><label>Cheque/Giro Date</label></b-input-group-prepend
                >
                <b-form-input
                  v-model="model.tgl_giro"
                  type="date"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12" v-if="model.jenis != 'Tunai'">
              <b-input-group>
                <b-input-group-prepend
                  ><label style="min-width: 180px !important">Bank Debitur</label></b-input-group-prepend
                >
                <b-form-input v-model="model.bankasal"></b-form-input>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend
                  ><label style="min-width: 180px !important">Finance Account</label></b-input-group-prepend
                >
                <b-form-input
                  readonly
                  v-model="model.namabank"
                  @keyup.13.native="lkuBankaccountShow = true"
                  :state="!$v.model.namabank.$error"
                ></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuBankaccountShow = true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
                <b-input-group-append>
                  <span class="input-group-text" style="width: 60px">{{
                    model.matauang
                  }}</span>
                </b-input-group-append>
              </b-input-group>
              <b-input-group v-if="this.model.isbank == '1'">
                <b-input-group-prepend
                  ><label style="min-width: 180px !important">Bank Account#</label></b-input-group-prepend
                >
                <b-form-input disabled v-model="model.nomorrek"></b-form-input>
              </b-input-group>

            </b-col>
          </b-row>
          <b-input-group class="bg-warning text-dark py-2 px-1">
                <b-input-group-prepend
                  ><label style="min-width: 180px !important">Suspend Account Code</label></b-input-group-prepend
                >
                <b-form-input
                  readonly
                  v-model="model.kodeacc"
                  @keyup.13.native="lkuCoaShow = true"
                  :state="!$v.model.glAccount.$error"
                ></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuCoaShow = true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
          </b-input-group>
          <b-input-group class="bg-warning text-dark py-2 px-1">
                <b-input-group-prepend
                  ><label style="min-width: 180px !important">Suspend Account Name</label></b-input-group-prepend
                >
                <b-form-input
                  readonly
                  v-model="model.namaacc"
                ></b-form-input>
          </b-input-group>
        </b-col>
        
      </b-row>
      <b-container class="bv-example-row mt-2">
        <b-row class="justify-content-md-center">>
          <b-col cols="12" md="auto">
            <b-input-group>
              <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
              <b-input-group-append class="ml-2">
                <div class="text-right">
                  <b-input-group>
                    <b-input-group-prepend
                      ><span class="p-2"
                        >Add Trx. after save</span
                      ></b-input-group-prepend
                    >
                    <b-form-checkbox
                      v-model="inputBerlanjut"
                      :value="1"
                      :unchecked-value="0"
                      class="pt-2"
                    ></b-form-checkbox>
                    <b-input-group-append>
                      <button
                        v-if="saveEnabled"
                        class="btn btn-primary mr-1"
                        @click="save()"
                      >
                        <i class="fa fa-save"></i> Save
                      </button>
                    </b-input-group-append>
                    <b-input-group-append>
                      <button class="btn btn-primary mr-1" @click="close()">
                        <i class="fa fa-close"></i> Close
                      </button>
                    </b-input-group-append>
                  </b-input-group>
                </div>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
      </b-container>
    </b-card>
    <b-modal
      v-model="lkuPinjamanShow"
      size="lg"
      :hide-footer="true"
      title="Daftar Pinjaman Lunas"
      :centered="true"
    >
      <lku-pinjaman
        @click="onSelectLkuPinjaman"
        :customer="model.custinfo"
        :nasabahkey="model.customer_id"
        :selectedrow="selectedPinjaman"
      ></lku-pinjaman>
    </b-modal>
    <b-modal
      v-model="lkuPinjamanoutstandShow"
      size="lg"
      :hide-footer="true"
      title="Daftar Pinjaman Outstanding"
      :key="model.customer_id"
      :centered="true"
    >
      <lku-pinjamanoutstand
        @click="onSelectLkuPinjamanoutstand"
        :customer="model.custinfo"
        :customer_id="model.customer_id"
        :wo_status="model.wo_status"
        :formdata="lkuPinjamanoutstandData"
        :selectedrow="selectedPinjamanOS"
      ></lku-pinjamanoutstand>
    </b-modal>
    <b-modal
      v-model="lkuCustomerShow"
      size="lg"
      :hide-footer="true"
      title="Daftar Debitur"
      :centered="true"
    >
      <lku-customer @click="onSelectLkuCustomer"></lku-customer>
    </b-modal>
    <b-modal
      v-model="lkuBankaccountShow"
      size="lg"
      :hide-footer="true"
      title="List of Bank/Cash Account"
      :centered="true"
    >
      <lku-bankaccount
        @click="onSelectLkuBankaccount"
        :isbank="bankOnly"
        :key="bankOnly"
      ></lku-bankaccount>
    </b-modal>
    <b-modal
      v-model="confirmPelunasanBthpShow"
      title="Konfirmasi"
      :centered="true"
      @ok="confirmPelunasanBertahap('Yes')"
      @cancel="confirmPelunasanBertahap('No')"
    >
      <p class="my-2">Pinjaman ini pelunasan bertahap/langsung</p>
    </b-modal>
    <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true" :lazy="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>   
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

  </div>
</template>
<style lang="scss">
.row-details-form {
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 120px;
    }
  }
  label {
    text-align: right !important;
  }
  legend {
    text-align: right !important;
  }
}

.my-number{
  min-width:100px;
}

.label-md{
  width:150px !important;
}
</style>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
// import vDim from "../lookup/dim";
import lkuPinjamanoutstand from "./lkuPinjamanoutstand";
import lkuPinjaman from "./lkuPinjamanLunas";
import lkuBankaccount from "../lookup/lkuBankaccount";
import lkuCashflow from "../lookup/lkuCashflow";
import lkuCustomer from "./lkuDebitur";
import lkuCoa from "../lookup/lkuCoa";

import arpayment from "../../apis/finpaymsuspend";
import produkkredit from '../../apis/produkkredit';
import crud from "../../apis/crud";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import { validationMixin } from "vuelidate";
import {
  required,
  requiredIf,
  requiredUnless,
  minValue,
  minLength,
  numeric,
} from "vuelidate/lib/validators";
toastr.init();

export default {
  components: {
    myNumber,
    lkuPinjamanoutstand,
    lkuPinjaman,
    lkuBankaccount,
    lkuCashflow,
    lkuCustomer,
    Loading,lkuCoa
  },
  mixins: [validationMixin],
  validations: {
    model: {
      // paymno: { required },
      uraian: { required },
      tglpaym: { required },
      jenis: { required },
      tgl_terima: {
        required: function () {
          if (this.model.jenis !== "Cheque" && this.model.jenis !== "Giro") {
            return true;
          } else if (this.model.tgl_terima) {
            return true;
          } else return false;
        },
      },
      // artype: { required:(function() {
      //     if (this.model.settl_amt==this.model.totalbyr) {
      //         return true;
      //     } else if (this.model.artype){
      //         return true;
      //     } else return false;
      // }) },
      namabank:{ required },
      matauang: { required },
      customer_id: { required:false },
      totalbank: { required, minValue: minValue(0.01) },
      totaldiskon: {
        required: requiredIf(function () {
          return this.adaNilaiDiskon;
        }),
        minValue: minValue(0.0),
      },
      kurstrx: { required, minValue: minValue(0.00000001) },
      glAccount: { required },
    },
    
  },
  data() {
    return {
      isLoading:false,
      arGroups: [],
      collectors: [],
      paym_group: [
        { text: "Normal", value: "NM" },
        { text: "WO", value: "WO" },
      ],
      selectedPinjamanOS: [],
      selectedPinjaman:[],
      currency: [{ value: "IDR", text: "IDR" }],
      potongans: [],
      saveEnabled: true,
      horizontal: true,
      jenisPaym: ["Cheque", "Giro", "Transfer", "Tunai"],
      tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
      model: {
        jenis: "Transfer",
        kodecash: "",
        kodebank: "",
        kurstrx: 1,
        tglpaym: this.$store.state.timeServer,
        tgl_terima: this.$store.state.timeServer,
        // tgl_terima:moment().format("YYYY-MM-DD"),
        totalbank: 0,
        totaldiskon: 0,
        matauang: "",
        custcode:"",
        CustName:"",
        customer_id: "",
        collector_id:"",
        settl_amt: 0,
        paym_group: "NM",
        pelunasan_bertahap:0,
        ismemo: 0,
        namabank:'',glAccount:"",custinfo:''
      },
      inputBerlanjut: 0,
      inputLineBerlanjut: 1,
      lblExchRate: "Exch. Rate ",
      bankOnly: 1,
      lkuBankaccountShow: false,
      lkuCashflowCaller: "arpaymdt",
      totalDtlPaym: 0,
      updateDimHdr: false,
      updateDimDtl: true,
      lkuPinjamanoutstandShow: false,
      lkuPinjamanShow: false,
      lkuCoaShow:false,
      addPrincipInterest: false,
      lkuPinjamanoutstandData: {},
      lkuCustomerShow: false,
      confirmPelunasanBthpShow: false,
      pelunasanbertahap: false,
      selectedOSPinjaman :{},
      tabIndex: 0,
      minpay: 0,
      items:[],fields: ['first_name', 'last_name', 'age'],
      tblDataMemo: {
        items:[],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "tglpelunasan",
        sortDesc: false,
        model_pinjaman: "",
        collector_id: "",
        collectability: "",
        status: "",nosurat:""
      },
      tblDataSP: {
        page: 1,
        limit: 15,
        total: 0,
        items:[],
        sortBy: "tglsurat",
        sortDesc: false,
        model_pinjaman: "",
        collector_id: "",
        collectability: "",
        kolektibiltas: "",
        jenissuratkey: null,
      },
    };
  },
  computed: {
    uanguser() {
      return this.$store.state.user.matauang;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidArpaymdt() {
      this.$v.arpaymdtObj.$touch();
      return this.$v.arpaymdtObj.$invalid;
    },
    // dimension(){
    //   return this.$store.state.dimension;
    // },
    caraBayar() {
      return this.model.jenis;
    },
    bankkas() {
      return this.model.kodebank;
    },
    adaNilaiDiskon() {
      return this.model.paym_group == "WO";
    },
  },
  watch: {
    caraBayar: function (jenis) {
      if (jenis === "Tunai") {
        this.bankOnly = "0";
      } else {
        this.bankOnly = "1";
      }
      // if (this.model.isbank!=this.bankOnly) {
      //     this.model.kodebank='';
      //     this.model.namabank='';
      // }
      if (!this.bankOnly) {
        this.model.kodebank = "";
        this.model.namabank = "";
      }
    },
    bankkas: function (kode) {
      if (this.uanguser.trim() == this.model.matauang.trim()) {
        this.model.kurstrx = 1;
      }
    },
    "model.tglpaym": function (newVal) {
      if(!this.$route.params.arpaymKey){
        this.model.tgl_terima=moment(newVal).format("YYYY-MM-DD");
      }
    }
  },
  created: async function () {
    this.model.matauang = this.uanguser;
    if (this.$route.params.arpaymsusKey) {
      toastr.info("Loading Payment Detail, please wait");
      this.isLoading = true;
      try {
        const [currency, potongan, data] = await Promise.all([
          arpayment.currency(),
          arpayment.potongan(),
          arpayment.detail(this.$route.params),
        ]);
        this.currency = currency;
        this.potongans = potongan;
        const row = data;
        this.saveEnabled = row.isvoid === 0;
        row.tglpaym = row.tglpaym
          ? moment(row.tglpaym).format("YYYY-MM-DD")
          : "";
        row.tgl_giro = row.tgl_giro
          ? moment(row.tgl_giro).format("YYYY-MM-DD")
          : "";
        row.tgl_terima = row.tgl_terima
          ? moment(row.tgl_terima).format("YYYY-MM-DD")
          : "";

        for (var key in row) {
          this.model[key] = row[key];
        }
        this.model.custinfo = row.custinfo;
        this.model.pinjamaninfo = row.no_agreement;
        this.model.isbank = row.jenis == "Transfer";
        this.model.glAccount = row.kodeacc.trim() + ' | ' + row.namaacc.trim();
        toastr.clear;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    } else {
      const [currency, potongan] = await Promise.all([
          arpayment.currency(),
          arpayment.potongan()
        ]);
        this.currency = currency;
        this.potongans = potongan;
        this.model.tglpaym = this.model.tglpaym
          ? moment(this.model.tglpaym).format("YYYY-MM-DD")
          : "";
    }
  },
  methods: {
    onSelectLkuCoa(_selected) {
        this.model.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        this.model.kodeacc = _selected.kodeacc;
        this.model.namaacc = _selected.namaacc;
        this.lkuCoaShow=false;
    },
    async onSelectLkuPinjaman(_selected){
      this.model.pinjamaninfo =`${_selected.no_agreement}` ;
      this.model.no_kontrak = _selected.no_kontrak;
      this.model.pinjamankey= _selected.pinjamankey;
      this.model.pelunasankey = _selected.pelunasankey;
      this.model.custcode = _selected.CustCode;
      this.model.CustName = _selected.CustName;
      this.model.customer_id = _selected.nasabahkey;
      this.model.collector_id = _selected.collector_id;
      this.model.custinfo =
        _selected.CustCode.trim() + " | " + _selected.CustName.trim();
      this.model.days_over_due = _selected.days_over_due;
      this.model.latecharge_outstand = _selected.latecharge_outstand;
      this.model.principal_outstand = _selected.principal_outstand;
      this.model.interest_outstand = _selected.interest_outstand;
      this.model.principal_outstand_undue = _selected.principal_outstand_undue;
      this.model.interest_outstand_undue = _selected.interest_outstand_undue;
      this.model.next_installment_no = _selected.next_installment_no;
      this.model.next_installment_due_no = _selected.next_installment_due_no;
      this.model.next_installment_date= _selected.next_installment_date ? moment(_selected.next_installment_date).format('DD-MM-YYYY') : _selected.next_installment_date;
      this.model.next_installment_due_date= _selected.next_installment_due_date ? moment(_selected.next_installment_due_date).format('DD-MM-YYYY') : _selected.next_installment_due_date;
      this.model.pbb_os= _selected.pbb_os;
      this.model.compcode = _selected.compcode;
      this.model.model_pinjaman = _selected.model_pinjaman;
      
      this.lkuPinjamanShow = false;
      if(_selected.wo_status == 1){
        this.model.paym_group = "WO";
      }
      if(_selected.pelunasan_bertahap == 1){
        this.model.pelunasan_bertahap = _selected.pelunasan_bertahap;
      }

      this.model.uraian = `Payment Suspend - ${_selected.no_agreement_no_point} - ${_selected.CustName}`;
      const detailProd = await produkkredit.detail(_selected.productkey);
      if(detailProd){
        this.onSelectLkuCoa({kodeacc:detailProd.Suspend_Account_No,namaacc:detailProd.Suspend_Account_Nm})
      }
    },
    save: async function () {
      if (!this.saveEnabled) {
        toastr.error("View mode cannot be Saved");
        return;
      }
      this.saveEnabled = false;
      if (this.invalidModel) {
        console.log("validation : ", this.$v.model);
        console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        this.saveEnabled = true;
      } else {
        try {
          this.isLoading=true;
          this.model.paymno = this.model.paymno || "";
          this.model.statusar = this.model.statusar || 0;
          this.model.statustre = this.model.statustre || 0;
          this.model.totalbyr = this.model.totalbyr || 0;
          this.model.totalbank = this.model.totalbank || 0;
          this.model.totaldiskon = this.model.totaldiskon || 0;
          this.model.bcharge = this.model.bcharge || 0;
          
          const row = {};
          for (var key in this.model) {
            row[key] = this.model[key];
          }
          row.tglpaym = moment(row.tglpaym).format("YYYY-MM-DD");
          row.tgl_giro = row.tgl_giro
            ? moment(row.tgl_giro).format("YYYY-MM-DD")
            : undefined;
          row.tgl_terima = row.tgl_terima
            ? moment(row.tgl_terima).format("YYYY-MM-DD")
            : moment(row.tglpaym).format("YYYY-MM-DD");
          const result = await arpayment.save(row);
          toastr.success(
            `Payment No : ${result.paymno} ,Complete successfully`,
            "Save Receipt"
          );
          this.isLoading=false;
          if (this.inputBerlanjut == 0) {
            const arpaylist={};
            const filter = this.$store.state.filter;
            arpaylist.tgl1=  moment(row.tglpaym).format("YYYY-MM-DD");
            arpaylist.tgl2=  moment(row.tglpaym).format("YYYY-MM-DD");
            filter.arpaylist=arpaylist;
            this.$store.commit("filter", filter);
            this.close();
          } else {
            this.saveEnabled = true;
            const jenis = this.model.jenis;
            for (var key in this.model) {
              this.model[key] = "";
            }
            this.model.jenis = jenis;
            this.model.matauang = this.$store.state.user.matauang;
            this.model.kurstrx = 1;
            this.model.settl_amt = 0;
            this.model.tglpaym = moment().format("YYYY-MM-DD");
            this.totalDtlPaym = 0;
            for (var key in this.arpaymdtObj) {
              this.arpaymdtObj[key] = "";
            }
            this.arpaymdt.items = [];
            this.arpaymdt.total = 0;
            this.calcTotalDtlPaym();
            this.$v.model.$reset();
          }
        } catch (error) {
          this.isLoading=false;
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
          this.saveEnabled = true;
        }
      }
    },
    updateNilaibank: function () {
      if (this.model.matauang == this.arpaymdtObj.matauang) {
        this.arpaymdtObj.nilaibank =
          this.arpaymdtObj.nilaisettl - (this.arpaymdtObj.nilaidiskon || 0);
      }
    },
    onSelectLkuPinjamanoutstand(invLookup) {
      if(invLookup.selected.pelunasan_bertahap==1){
        this.selectedOSPinjaman = invLookup;
        this.confirmPelunasanBthpShow = true;
      }else{
        this.handleselectPinjamanoutstand(invLookup) 
      }
    },
    onSelectLkuBankaccount(_selected) {
      this.model.kodebank = _selected.kode;
      this.model.matauang = _selected.matauang;
      this.model.namabank = _selected.namabank;
      this.model.nomorrek = _selected.nomorrek;
      this.model.isbank = _selected.isbank;
      this.lkuBankaccountShow = false;
    },
    onSelectLkuCustomer: async function (_selected) {
      this.model.custinfo =
        _selected.CustCode.trim() + " | " + _selected.CustName.trim();
      this.model.custcode = _selected.CustCode;
      this.model.CustName = _selected.CustName;
      this.model.customer_id = _selected.nasabahkey;
      this.model.collector_id = _selected.collector_id;
      this.lkuCustomerShow = false;
    },
    close() {
      router.push({ name: "loan.paymsuspendlist" });
    },
    viewaggrementcard(){
      const url = router.resolve({name:'loan.agreementcardparams',params:{pinjamankey:this.model.pinjamankey}}).route.path;
      return `#`+url;
    },
  },
};
</script>
